import http from '../utils/http';
import i18n from '@/main';

const URL_BASE = 'transacao';

function realizarDownload(response) {
    const fileLink = document.createElement('a');
    try {
        if (response.status === 200) {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            fileLink.href = fileURL;

            const contentDisposition = response.headers['content-disposition'] || '';
            const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
            const headerMatch = filenameRegex.exec(contentDisposition);
            const filename = headerMatch ? headerMatch[1] : 'download.xlsx';

            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);

            fileLink.click();
            window.URL.revokeObjectURL(fileURL);
            return Promise.resolve();
        }
    } finally {
        fileLink.remove();
    }
}

function postDownload(url, data) {
    return http
        .post({
            url,
            responseType: 'blob',
            data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
        })
        .then(realizarDownload);
}

export default {
    listarNotasEntradaPaginado(body, page, size) {
        return http.post({
            url: `${URL_BASE}/nota-entrada-grid-paginado?page=${page}&size=${size}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacoesArmazens')
        });
    },

    downloadPlanilhaAnalise(idsFilaProcessamento) {
        return postDownload(
            `${URL_BASE}/nota-entrada-download-planilha-analise`,
            { idsFilaProcessamento, locale: i18n.locale }
        );
    },

    downloadPlanilhaAnalisePorFiltro(filtros) {
        const body = {
            filtroTexto: filtros.filtroTexto || '',
            dataInicio: filtros.dataInicio || null,
            dataFim: filtros.dataFim || null,
            locale: i18n.locale
        };

        return postDownload(
            `${URL_BASE}/nota-entrada-download-planilha-analise-todos`,
            body
        );
    }
};
